<template>
  <div class="body">
    <div class="detay">
      <router-view></router-view>
    </div>
  </div>
</template>
<script>
  export default {
    data() {
      return {}
    },
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/_Sayac/_route.vue